import useClipVersions from '@/hooks/useClipVersions';
import { formatVersionTime } from '@/Pages/Clip/ClipPlayer/ClipCustomizer/ClipCustomizerVersioningPanel/utils';

export default function ViewModeBanner() {
  const { viewingVersion, exitViewMode } = useClipVersions();

  if (!viewingVersion) {
    return null;
  }

  const timeLabel = formatVersionTime(viewingVersion.created_at);

  return (
    <div className="align-center mt-2 flex w-[97%] shrink-0 items-center gap-2 rounded-[10px] border border-[#ffe9d3] bg-[#fff5ec] p-3">
      <p className="flex-1 text-sm font-medium leading-5 text-slate-700">
        Viewing an older version{timeLabel ? ` from ${timeLabel}` : ''}. To edit the project, return to the latest
        version or restore this version.
      </p>
      <button
        onClick={exitViewMode}
        className="h-6 min-w-[36px] cursor-pointer rounded-md border-0 bg-[#fff5ec] p-1 text-xs font-medium leading-[18px] text-orange-600"
      >
        Exit
      </button>
    </div>
  );
}
